import React, { useState, useContext, useEffect } from "react";

import AlertsContext from "../../Contexts/Alertas/AlertasContext";
import AuthContext from "../../Contexts/Autenticacion/authContext";

const SingUp = (props) => {
  const { mostrarAlerta } = useContext(AlertsContext);
  const { registrarUsuario, autenticado } = useContext(AuthContext);

  useEffect(() => {
    if (autenticado) {
      props.history.push("/dashboard");
    }
  }, [autenticado]);

  const [forms, setForms] = useState({
    firstForm: true,
    secondForm: false,
  });

  const [dataSingUp, setDataSingUp] = useState({
    name: "",
    lastname: "",
    email: "",
    password: "",
    passwordforvalidate: "",
    username: "",
    rol: "",
  });

  const onChangeDataSingUp = (e) => {
    setDataSingUp({ ...dataSingUp, [e.target.name]: e.target.value });
  };
  const {
    name,
    lastname,
    email,
    password,
    passwordforvalidate,
    username,
    rol,
  } = dataSingUp;

  const handleFirstSubmit = (e) => {
    e.preventDefault();

    if (dataSingUp.email.trim() === "" || dataSingUp.password.trim() === "") {
      mostrarAlerta("Faltan datos", "warning");
      return;
    } else if (dataSingUp.password != dataSingUp.passwordforvalidate) {
      mostrarAlerta("Las contraseñas no coinciden", "warning");
      return;
    }
    setForms({
      firstForm: false,
      secondForm: true,
    });
  };
  const handleSecondSubmit = (e) => {
    e.preventDefault();

    if (
      dataSingUp.name.trim() === "" ||
      dataSingUp.lastname.trim() === "" ||
      dataSingUp.rol.trim() === "" ||
      dataSingUp.username.trim() === ""
    ) {
      mostrarAlerta("Faltan datos", "error");
      return;
    }
    console.log(dataSingUp, "La data que se envia del formulario");

    const { passwordforvalidate, ...rest } = dataSingUp;

    try {
      registrarUsuario(rest);
    } catch (error) {
      console.log(error);
      mostrarAlerta("Ha ocurrido un error en el servidor", "error");
    }
  };

  return (
    <div className="container min-vh-100 d-flex justify-content-center align-items-center">
      {forms.firstForm ? (
        <form onSubmit={handleFirstSubmit}>
          <div className="form-group">
            <label htmlFor="exampleInputEmail1">Email address</label>
            <input
              type="email"
              name="email"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              onChange={onChangeDataSingUp}
              value={email}
            />
            <small id="emailHelp" className="form-text text-muted">
              We'll never share your email with anyone else.
            </small>
          </div>
          <div className="form-group">
            <label for="exampleInputPassword1">Password</label>
            <input
              type="password"
              className="form-control"
              id="exampleInputPassword1"
              name="password"
              onChange={onChangeDataSingUp}
              value={password}
            />
          </div>
          <div className="form-group">
            <label for="exampleInputPassword1">Repeat Password</label>
            <input
              type="password"
              className="form-control"
              name="passwordforvalidate"
              id="exampleInputPassword1"
              onChange={onChangeDataSingUp}
              value={passwordforvalidate}
            />
          </div>
          <button
            type="submit"
            className="btn btn-block btn-outline-dark rounded-0 mt-4 mb-2"
          >
            Ingresar
          </button>
          <button
            type="submit"
            className="btn btn-block btn-outline-secondary rounded-0 my-2"
          >
            Ingresar con Google
          </button>
          <button
            type="submit"
            className="btn btn-block btn-outline-primary my-2 rounded-0"
          >
            Ingresar con Facebook
          </button>
        </form>
      ) : null}
      {forms.secondForm ? (
        <form action="" onSubmit={handleSecondSubmit}>
          <div className="row">
            <div className="col">
              <label htmlFor="exampleInputEmail1">Name</label>
              <input
                type="text"
                name="name"
                className="form-control"
                placeholder="First name"
                onChange={onChangeDataSingUp}
                value={name}
              />
            </div>
            <div className="col">
              <label htmlFor="exampleInputEmail1">Last Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Last name"
                name="lastname"
                onChange={onChangeDataSingUp}
                value={lastname}
              />
            </div>
          </div>
          <div className="row my-3">
            <div className="col">
              <label className="sr-only" htmlFor="inlineFormInputGroup">
                Username
              </label>
              <div className="input-group mb-2">
                <div className="input-group-prepend">
                  <div className="input-group-text">@</div>
                </div>
                <input
                  type="text"
                  className="form-control"
                  id="inlineFormInputGroup"
                  placeholder="Username"
                  name="username"
                  onChange={onChangeDataSingUp}
                  value={username}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <select
                className="form-control form-control-sm"
                name="rol"
                onChange={onChangeDataSingUp}
                value={rol}
              >
                <option value="">--seleccione--</option>
                <option value="Hija">Hija</option>
                <option value="Hijo">Hijo</option>
                <option value="Padre">Padre</option>
                <option value="Madre">Madre</option>
              </select>
            </div>
          </div>
          <button
            type="submit"
            className="btn btn-block btn-outline-dark rounded-0 mt-4 mb-2"
            onClick={handleSecondSubmit}
          >
            Ingresar
          </button>
        </form>
      ) : null}
    </div>
  );
};

export default SingUp;
